import React from "react"
import { T } from "../../traks"

const InvalidInput = (props) => <p className={`${props.darkbg ? "txt_yellow " : "txt_red "}text-start my-0 ps-1 fw_500 font_14px`}>{props.children}</p>

const requiredTextFieldValidator = (value) => {
	return value && value.length > 1
}

const RequiredField = (props) => <InvalidInput {...props}><T>This is a required field</T></InvalidInput>

const emailValidator = (email) => {
	const re = /^(?=.*[@]).*$/
	if (!re.test(email)) {
		return false
	} else {
		return true
	}
}

const passwordValidator = (password) => {
	const re = /^(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
	if (!re.test(password)) {
		return false
	} else {
		return true
	}
}

const rePasswordValidator = (rePassword, password) => {
	if (rePassword !== password) {
		return false
	} else {
		return true
	}
}
const reEmailValidator = (reEmail, Email) => {
	if (reEmail !== Email) {
		return false
	} else {
		return true
	}
}

const NameErrorText = ({name, showEmptyWarning, darkbg=false}) => {
	if (!requiredTextFieldValidator(name) && showEmptyWarning) {
		return <RequiredField  darkbg={darkbg}/>
	}else{
		return null
	}
}
const CompanyErrorText = ({name, showEmptyWarning, darkbg=false}) => {
	if (!requiredTextFieldValidator(name) && showEmptyWarning) {
		return <RequiredField darkbg={darkbg} />
	}else{
		return null
	}
}

const CompanyAddressErrorText = ({street, city, zipcode, showEmptyWarning}) => {
	if (
        (
            !requiredTextFieldValidator(street) 
            || !requiredTextFieldValidator(city)
            || !requiredTextFieldValidator(zipcode)
        ) 
        && showEmptyWarning
    ) {
        return <InvalidInput> <T>Company address is required</T> </InvalidInput>
	}else{
		return null
	}
}
const PhoneErrorText = ({phone, showEmptyWarning, darkbg=false }) => {
	if (!requiredTextFieldValidator(phone) && showEmptyWarning) {
		return <RequiredField darkbg={darkbg}/>
	}else{
		return null
	}
}

const EmailErrorText = ({ value, showEmptyWarning, darkbg=false }) => {
	if (showEmptyWarning) {
		if (value.length === 0)
			return <RequiredField darkbg={darkbg}/>

		if (!emailValidator(value)) {
			return <InvalidInput darkbg={darkbg}> <T>Not a valid email</T> </InvalidInput>
		} else {
			return null
		}
	}

	return null
}

const PasswordErrorText = ({ value, showEmptyWarning }) => {
	if (showEmptyWarning) {
		if (value.length === 0)
			return null

		if (!passwordValidator(value)) {
			return <InvalidInput> <T>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</T> </InvalidInput>
		} else {
			return null
		}
	}

	return null
}

const ReEmailErrorText = ({ value, refValue, showEmptyWarning }) => {
	if (!reEmailValidator(value, refValue) && showEmptyWarning){
		return <InvalidInput> <T>Emails do not match</T> </InvalidInput>
	}

	return null
}

const RePasswordErrorText = ({ value, refValue, showEmptyWarning }) => {
	if (!rePasswordValidator(value, refValue) && showEmptyWarning)
		return <InvalidInput> <T>Passwords do not match</T> </InvalidInput>

	return null
}


export {
	InvalidInput,
	emailValidator,
	passwordValidator,
	rePasswordValidator,
	reEmailValidator,
	NameErrorText,
	CompanyErrorText,
	PhoneErrorText,
	EmailErrorText,
	PasswordErrorText,
	ReEmailErrorText,
	RePasswordErrorText,
    CompanyAddressErrorText
}
